export default {
  // FrontPage.vue
  frontPageRequirementTitle: 'Perlukan',
  frontPageProvideTitle: 'Tawarkan',
  frontPagePersonalCenterTitle: 'Profil',
  login: 'Log Masuk',
  home_chatWithOctopie: 'Memahami pemikiran anda',
  home_chatNeedUnderstood: 'Pemikiran anda telah difahami',
  home_draftBannerTitle: 'Selesaikan mesej anda',
  home_draftBannerSubtitle: 'AI telah menyediakan mesej anda — ketuk untuk teruskan',
  home_tabHome: 'Utama',

  // App.vue
  appRequirementTitle: 'Kami menghargai setiap cadangan dan maklum balas',
  appRequirementBtn: 'Hantar',
  appSubmitSuccess: 'Berjaya dihantar, terima kasih atas maklum balas anda',
  appFeedbackLink: 'Cadangan/Maklum Balas',
  mobile_banner_text: 'Untuk pengalaman terbaik, gunakan aplikasi kami',
  mobile_banner_btn: 'Dapatkan Aplikasi',

  // Common
  loading: 'Memuatkan...',
  confirm: 'Sahkan',
  cancel: 'Batal',
  save: 'Simpan',
  delete: 'Padam',
  edit: 'Sunting',
  add: 'Tambah',
  search: 'Cari',
  refresh: 'Muat semula',
  change_batch: 'Susun semula',
  back: 'Kembali',
  submit: 'Hantar',
  close: 'Tutup',
  ok: 'OK',
  yes: 'Ya',
  no: 'Tidak',
  send: 'Hantar',
  block: 'Sekat',
  more: 'Lagi',
  logout: 'Log Keluar',
  settings: 'Tetapan',
  view_guide: 'Lihat Panduan',
  feedback: 'Maklum Balas',
  feedback_title: 'Maklum Balas',
  feedback_new: 'Maklum Balas Baharu',
  feedback_empty: 'Belum ada maklum balas',
  feedback_hint: 'Kongsi pendapat anda...',
  feedback_submit: 'Hantar',
  feedback_submit_success: 'Maklum balas berjaya dihantar',
  feedback_submit_failed: 'Gagal menghantar maklum balas',
  feedback_reply_label: 'Balasan Platform',
  register: 'Daftar',
  name: 'Nama',
  email: 'E-mel',
  mobile: 'Telefon',
  password: 'Kata laluan',
  verification_code: 'Kod pengesahan',
  company_name: 'Beijing Liangshao Technology Co., Ltd.',
  all_rights_reserved: 'Hak cipta terpelihara.',
  footerVersion: 'Versi {version}',
  copy: 'Salin',
  regenerate: 'Jana semula',
  generate: 'Jana',
  contact_now: 'Sembang',
  yours: 'anda',
  xiaoyao_analysis: 'Analisis AI',
  brand_name: 'OctoSay',
  anonymous: 'Tanpa nama',
  no_summary: 'Tiada ringkasan',
  file: 'Fail',
  discover: 'Terokai',
  discover_title: 'Terokai',
  discover_hotChannels: 'Saluran Popular',
  discover_allChannels: 'Semua',
  discover_searchChannel: 'Cari saluran',
  discover_noChannels: 'Tiada saluran ditemui',

  // Messages
  operationSuccess: 'Operasi berjaya',
  operationFailed: 'Operasi gagal',
  networkError: 'Ralat rangkaian, sila cuba lagi kemudian',
  dataLoadingFailed: 'Gagal memuatkan data',
  noData: 'Tiada data',
  deleteConfirm: 'Adakah anda pasti mahu memadam?',
  saveConfirm: 'Adakah anda pasti mahu menyimpan?',

  // Form Validation
  required: 'Medan ini wajib diisi',
  emailInvalid: 'Sila masukkan alamat e-mel yang sah',
  phoneInvalid: 'Sila masukkan nombor telefon yang sah',
  passwordTooShort: 'Kata laluan sekurang-kurangnya {min} aksara',
  passwordMismatch: 'Kata laluan tidak sepadan',

  // Time
  today: 'Hari ini',
  yesterday: 'Semalam',
  justNow: 'Baru sahaja',
  minutesAgo: '{min} minit lalu',
  hoursAgo: '{hour} jam lalu',
  daysAgo: '{day} hari lalu',

  // Footer
  about: 'Perihal',
  footerPrivacy: 'Dasar Privasi',
  footerTerms: 'Terma Perkhidmatan',
  footerSupport: 'Bantuan & Sokongan',

  // Register
  registerAgeConfirm: 'Saya mengesahkan bahawa saya berumur sekurang-kurangnya 13 tahun',
  registerAgeConfirm18: 'Saya mengesahkan bahawa saya berumur sekurang-kurangnya 18 tahun',
  registerTermsPrefix: 'Saya telah membaca dan bersetuju dengan ',
  registerTermsAnd: ' dan ',
  registerAgeError: 'Sila sahkan umur anda',
  registerTermsError: 'Sila terima terma dan dasar privasi',

  // Chat
  chatPrivacyTip: 'Taip mesej anda dalam hub dan AI akan berbual dengan anda dahulu untuk menjelaskan. Selepas anda mengesahkan, mesej dan ringkasan AI anda disiarkan bersama dan AI terus mencari padanan.',
  aiChat_quickSuggestions: 'Cuba katakan',
  aiChat_welcome: "Hai! Beritahu apa yang anda cari.",

  // Chat - AI Progress Steps (new)
  aiChat_readyToPost: 'Butiran difahami — siarkan untuk mencari padanan anda',
  aiChat_readyToPostHint: 'Teruskan berbual untuk menambah butiran atau mengemas kini ringkasan pada bila-bila masa',
  aiChat_progressStep1: 'Fahami butiran',
  aiChat_progressStep1Done: 'Butiran difahami',
  aiChat_progressStep2: 'Ringkasan AI',
  aiChat_progressStep2Desc: 'AI mencipta ringkasan untuk pemadanan',
  aiChat_progressStep3: 'Siar ke Kumpulan',
  aiChat_progressStep3Desc: 'Siarkan dan cari padanan anda',
  aiChat_publishExtraHint: 'Masukkan mesej anda untuk hub',
  aiChat_publishMsgRequired: 'Wajib',
  aiChat_publishMsgLabel: 'Mesej anda untuk hub',
  aiChat_matchSummaryLabel: 'Ringkasan AI',

  ai_generated_label: 'AI Generated',

  ai_content_disclaimer: 'Kandungan berikut dijana oleh AI dan untuk rujukan sahaja.',
  aiChat_publishSuggestionHint: 'Ketik untuk menggantikan',
  aiChat_allowDirectContact: 'Benarkan hubungan terus',
  aiChat_allowDirectContactDesc: 'Orang lain boleh menghubungi anda secara terus tanpa perlu dipadankan',
  channel_chat_session_publishToChannel: 'Siar ke Kumpulan Octo',
  aiChat_newChat: 'Set Semula',

  // Channels / Kumpulan
  home_tabChannels: 'Kumpulan Octo',
  channels_title: 'Kumpulan Octo',
  channels_myChannels: 'Kumpulan yang Disertai',
  channels_discover: 'Terokai',
  channels_noChannels: 'Belum ada hub',
  channels_noMyGroupsTitle: 'Anda belum menyertai sebarang hub',
  channels_noMyGroupsSubtitle: 'Cari hub untuk disertai dan mula berhubung',
  channels_searchGroupsBtn: 'Cari Kumpulan',
  channels_loginPrompt: 'Sila log masuk untuk melihat hub',
  channels_create: 'Cipta Kumpulan Octo',
  channels_search: 'Cari Kumpulan Octo',
  channels_searchMyGroups: 'Cari Kumpulan Octo saya',
  channels_searchHint: 'Cari',
  channels_searchHintChats: 'Cari sembang...',
  channels_searchHintGroups: 'Cari hub...',
  channels_searchHintMy: 'Cari hub yang disertai...',
  channels_joinByCode: 'Sertai dengan Kod',
  channels_joinByCodeTitle: 'Sertai Kumpulan Octo dengan Kod',
  channels_joinByCodeHint: 'Masukkan kod Kumpulan Octo',
  channels_joinByCodeConfirm: 'Sertai',
  channels_joinByCodeNotFound: 'Kumpulan tidak ditemui',
  channels_createNewGroup: 'Cipta Kumpulan Octo baharu',
  channels_noResults: 'Tiada hub ditemui',
  channel_detail_join: 'Sertai',
  channel_detail_leave: 'Keluar',
  channel_detail_members: 'ahli',
  // 聚合进群消息 banner（joinMsgs）
  channelJoinMsg_oneJoined: '{name} menyertai hub',
  channelJoinMsg_twoJoined: '{name1} dan {name2} menyertai hub',
  channelJoinMsg_multiJoined: '{name1}, {name2} dan {n} orang lain menyertai hub',
  channelJoinMsg_oneAndMoreJoined: '{name} dan {n} orang lain menyertai hub',
  channelJoinMsg_membersJoined: '{n} ahli menyertai hub',

  // Feed
  channels_feed: 'Sembang',
  channels_groups: 'Kumpulan',
  feed_related: 'Berkaitan',
  feed_recommend: 'Cadangan',
  feed_empty: 'Belum ada suapan, terokai hub popular',
  feed_goToGroup: 'Lihat dalam hub',
  feed_joinGroupAndSendMsg: 'Sertai hub dan hantar mesej',
  channel_detail_channelCode: 'Kod Kumpulan Octo',
  channel_detail_invitePhrase: 'Jemputan menyertai "{name}"\nKod jemputan {code} — buka aplikasi untuk sertai automatik · AI jelaskan dahulu, kemudian cari orang yang sesuai',
  channel_detail_post: 'Siar ke Kumpulan',
  channel_detail_aiHint: "Taip mesej anda dalam hub dan AI akan menjelaskan butiran dahulu",
  channel_input_hint: 'Katakan sesuatu...',
  channel_leave_confirm_message: 'Adakah anda pasti mahu keluar dari hub ini? Anda tidak akan lagi menerima mesej hub.',
  channel_invite_notFound: 'Kumpulan tidak ditemui atau pautan telah tamat tempoh',
  channel_invite_joinBtn: 'Muat Turun Aplikasi OctoSay',
  channel_invite_hint: 'Muat turun aplikasi, kemudian imbas kod QR ini atau cari nama hub untuk menyertai',
  channel_invite_globalHintTitle: 'Anda akan memuat turun versi Global',
  channel_invite_globalHintIOS: 'Aplikasi ini mungkin tidak tersedia di App Store China. Sila tukar ke Apple Store di luar China dan cari OctoSay, atau muat turun APK secara terus di bawah.',
  channel_invite_globalHintAndroid: 'Google Play mungkin tidak boleh diakses di rantau anda. Kami mengesyorkan memuat turun APK secara terus, atau cuba Google Play.',
  channel_invite_globalHintDefault: 'Aplikasi mungkin tidak tersedia di app store tempatan. Kami mengesyorkan memuat turun APK secara terus, atau cuba App Store.',
  channel_invite_globalBtnAppStore: 'Ke App Store',
  channel_invite_globalBtnGooglePlay: 'Ke Google Play',
  channel_invite_globalBtnAPK: 'Muat Turun APK Terus',
  channel_invite_defaultDesc: 'Sertai {name} di OctoSay',
  share: 'Kongsi',
  share_channel: 'Kongsi Kumpulan',
  share_channel_link: 'Kongsi Pautan',
  channel_detail_inviteCode: 'Kod Jemputan',
  channel_detail_copyLink: 'Salin Pautan',
  share_session_title: 'Siaran di OctoSay',
  share_match_title: 'Padanan di OctoSay',
  share_session_text: '{userName}: {summary}',
  share_session_text_no_summary: 'Lihat apa yang {userName} siarkan di OctoSay',
  session_share_notFound: 'Siaran tidak ditemui atau pautan telah tamat tempoh',
  session_share_fromChannel: 'Dari Kumpulan Octo',
  session_share_downloadBtn: 'Muat Turun Aplikasi OctoSay',
  session_share_hint: 'Muat turun aplikasi untuk melihat siaran penuh dan menyertai hub',
  session_share_openInApp: 'Buka dalam Aplikasi',
  toast_link_copied: 'Pautan disalin',
  toast_no_share_data: 'Tiada kandungan untuk dikongsi',
  channels_joinByQR: 'Kod QR',
  channels_joinByQRWebHint: 'Web tidak menyokong imbasan QR. Sila masukkan kod hub untuk menyertai.',
  channels_joinByQRTitle: 'Sertai dengan Kod QR',
  channel_detail_qrCode: 'Kod QR',
  channel_detail_qrCodeSave: 'Simpan Imej',
  channel_detail_qrCodeSaveHint: 'Klik kanan imej untuk menyimpan',
  channel_detail_qrCodeSaved: 'Disimpan ke album',
  channel_detail_qrCodeSaveFailed: 'Gagal menyimpan, sila cuba lagi',
  channel_detail_locateFailed: 'Gagal mencari lokasi mesej',
  channel_detail_locateError: 'Ralat mencari lokasi mesej',
  channel_detail_myMessages: 'Mesej Saya',
  channel_detail_searchMessages: 'Cari Mesej',
  channel_detail_aiChat: 'Sembang AI',
  channel_detail_matchHistory: 'Sejarah Padanan',
  channel_create_title: 'Cipta Kumpulan Octo',
  channel_create_name: 'Nama Kumpulan Octo',
  channel_create_description: 'Penerangan',
  channel_create_submit: 'Cipta',
  channelCreate_aiAssist: 'AI akan membantu anda mencipta hub yang sesuai',
  channelCreate_nameHint: 'Masukkan nama untuk hub anda',
  channelCreate_descHint: 'Terangkan tentang apa hub anda',
  channelCreate_creating: 'Mencipta...',
  channelCreate_created: 'Kumpulan dicipta!',
  channelCreate_failed: 'Gagal mencipta hub',
  channelCreate_welcomeMsg: "Hai! Saya di sini untuk membantu anda mencipta hub. Beritahu saya hub macam mana yang anda mahu — namanya, topiknya atau tujuannya — dan saya akan bantu menukarkannya kepada nama hub dan pengenalan hub, serta menjana gambar profil.",
  channelCreate_aiHint: 'Tulis topik hub anda...',
  channelCreate_clarifyingProgress: 'Menyusun topik hub anda...',
  channelCreate_readyToCreate: 'Sedia mencipta Kumpulan Octo',
  channelCreate_step1: 'Terangkan Topik',
  channelCreate_step1Done: 'Idea sudah jelas',
  channelCreate_step2: 'Cipta Kumpulan Octo',
  channelCreate_confirmBtn: 'Sahkan Penciptaan',
  channelCreate_publicNotice: 'Kumpulan ialah ruang awam untuk orang yang berkongsi minat berkumpul dan berhubung. Platform boleh mengurus, mengemas kini atau menggabungkan hub mengikut keperluan. Sila kongsi hub ini dengan orang lain yang mungkin berminat.',
  channelCreate_similarGroupsTitle: 'Kumpulan Octo Serupa Ditemui',
  channelCreate_similarGroupsDesc: 'Kumpulan-hub ini mungkin sesuai dengan yang anda mahu',
  channelCreate_exactMatchHint: 'Kumpulan dengan nama yang sama tepat sudah wujud!',
  channelCreate_joinHint: 'Kumpulan sedia ada ini mungkin sesuai',
  channelCreate_joinExisting: 'Sertai Kumpulan Octo Sedia Ada',
  channelCreate_stillCreate: 'Tetap Cipta Kumpulan Octo Baharu',
  channel_chat_session_comments: 'Ulasan',
  channel_chat_session_commentHint: 'Tulis ulasan...',
  channel_chat_session_sendComment: 'Ulasan',
  channel_chat_session_loadMore: 'Muat lagi',
  channel_chat_session_noComments: 'Belum ada ulasan',
  channel_chat_session_deleteComment: 'Padam',
  channelSearch_title: 'Cari dalam Kumpulan',
  channelSearch_placeholder: 'Cari mesej...',
  channelSearch_onlyMine: 'Hanya siaran saya',
  channelSearch_tabAllMessages: 'Mesej Kumpulan',
  channelSearch_tabMyMessages: 'Mesej Saya',
  chatMsgSearch_placeholder: 'Cari mesej',
  chatMsgSearch_tabMsgs: 'Mesej',
  chatMsgSearch_tabContacts: 'Kenalan',
  chatMsgSearch_emptyPrompt: 'Taip kata kunci untuk mencari mesej',
  chatMsgSearch_tooShort: 'Taip sekurang-kurangnya 2 aksara untuk mencari',
  chatMsgSearch_contactEmptyPrompt: 'Taip nama pengguna atau e-mel untuk mencari kenalan',
  chatMsgSearch_noContacts: 'Tiada kenalan sepadan',
  chatMsgSearch_inChatPlaceholder: 'Cari dalam sembang ini',
  channelHistory_title: 'Sejarah',
  channelHistory_myMessages: 'Mesej Saya',
  channelHistory_loadMore: 'Muat lagi',
  channel_settings_push: 'Pemberitahuan Kumpulan Octo',
  channel_settings_commentPush: 'Pemberitahuan Ulasan',
  channel_settings_likePush: 'Pemberitahuan Sukaan',
  channel_settings_receiveNotifications: 'Terima Pemberitahuan',
  channel_settings_directContact: 'Benarkan Hubungan Terus',
  session_published: 'Disiarkan',
  session_publishFailed: 'Gagal menyiarkan',
  session_setDirectContactSuccess: 'Tetapan disimpan',
  session_setDirectContactFailed: 'Gagal menyimpan tetapan',
  session_setPrivate: 'Jadikan Peribadi',
  session_setPublic: 'Jadikan Awam',
  session_pauseMatching: 'Jeda padanan',
  session_resumeMatching: 'Sambung semula padanan',
  session_matchPausedToast: 'Padanan dijeda',
  session_matchResumedToast: 'Padanan disambung semula',
  match_matchingPausedTitle: 'Padanan dijeda',
  match_reasonTag: 'Sebab padanan',
  match_matchingPausedHint: 'Sambung semula padanan bila-bila masa.',
  session_confirmSetPrivate: 'Jadikan kandungan ini peribadi? Pengguna lain tidak akan dapat melihatnya.',
  session_messageIsPrivate: 'Mesej ini peribadi',
  chatSessionComment_replyHint: 'Tulis ulasan...',
  chatSessionComment_reply: 'Ulasan',
  chatSessionComment_count: '{n} ulasan',
  chatSessionMatch_count: '{n} padanan',
  chatSessionComment_replyTo: 'Balas',
  chatSessionComment_inputHint: 'Tulis ulasan...',
  chatSessionComment_send: 'Hantar',
  chatSessionComment_delete: 'Padam',
  chatSessionComment_deleteConfirm: 'Adakah anda pasti mahu memadam ulasan ini?',
  chatSessionComment_loadMore: 'Muat lagi',
  chatSessionComment_noMore: 'Tiada lagi ulasan',
  chatSessionComment_loginToComment: 'Sila log masuk untuk mengulas',
  chatSessionComment_viewEarlier: 'Lihat {n} balasan terdahulu',
  chatSessionLike_like: 'Suka',
  chatSessionLike_liked: 'Disukai',
  chatSessionLike_count: 'suka',
  chatSessionBookmark_bookmark: 'Simpan',
  chatSessionBookmark_bookmarked: 'Disimpan',
  chatSessionMatch_viewMatches: 'Lihat Padanan',
  chatSessionMatch_matchHistory: 'Sejarah Padanan',
  chatSessionMatch_noMatches: 'Belum ada padanan',
  channel_match_achievement: '{count} siaran berjaya dipadankan',
  channel_match_achievement_view: 'Lihat →',
  channel_matchHistory_title: 'Sejarah Padanan Saluran',
  chatSessionMatch_matchedAt: 'Dipadankan pada {time}',
  discover_userMsgLabel: 'Pengguna berkata',
  common_loading: 'Memuatkan...',
  common_sending: 'Menghantar...',
  common_error: 'Ralat',
  common_success: 'Berjaya',
  common_me: 'Saya',

  // Chat - Set Public / Pick Location
  aiChat_clarifyingProgress: "AI sedang menjelaskan keperluan anda supaya setiap mesej yang disiarkan berkesan; selepas disiarkan, AI terus mencari padanan untuk anda",
  aiChat_clarifyingAlmostDone: 'Hampir siap, sila sahkan',
  aiChat_clarifyingOneMore: 'Tinggal lebih kurang 1 soalan lagi, kemudian anda boleh menyiarkan',
  aiChat_clarifyingRemaining: 'Tinggal lebih kurang {count} pusingan lagi, hampir siap',
  aiChat_clarifyingEvaluating: 'Menilai kemajuan...',
  aiChat_setPublicMatch: 'Jadikan Awam & Padankan',
  aiChat_needsClarifiedPublic: "Saya faham anda sekarang. Selepas anda mengesahkan dan menyiarkan, AI akan terus mencari padanan untuk anda.\nKongsi lebih banyak butiran pada bila-bila masa.",
  aiChat_needsClarifiedPrivate: 'Dah faham! Jadikan awam & biar saya terus mencari padanan!\nAnda boleh beritahu saya lebih banyak butiran pada bila-bila masa.',
  aiChat_setPublicTitle: 'Jadikan Awam',
  aiChat_setPublicMessage: 'Kandungan anda akan dipaparkan kepada orang lain supaya OctoSay dapat mencari padanan yang melengkapi.\n\nMaklumat yang akan dikongsi:\n• Nama pengguna dan avatar anda\n• Ringkasan kandungan anda\n• Kandungan perbualan (dipaparkan dalam Terokai)\n\nAnda boleh menjadikannya peribadi semula pada bila-bila masa.',
  aiChat_findMatches: 'Lihat Hasil Padanan',
  aiChat_publishing: 'Sedang menyiarkan...',
  aiChat_matchSectionTitle: 'Mesej anda paling sesuai dengan kumpulan ini — ketik untuk siar',
  aiChat_joinedBadge: 'Menyertai',
  aiChat_matchSectionEmpty: 'Belum ada kumpulan yang sepadan — anda boleh cipta kumpulan baharu dan siar di sana',
  aiChat_suggestPublishCreateNew: 'Cipta kumpulan baharu',
  aiChat_repickChannel: 'Tukar kumpulan',
  aiChat_creatingChannelTitle: 'Tiada kumpulan sesuai — sedang menciptakan untuk anda',
  aiChat_creatingChannelHint: 'AI sedang mencipta kumpulan mengikut permintaan anda, selepas itu terus siar — biasanya 10-30 saat',
  aiChat_publishToChannelHint: 'Akan disiar ke "{name}"',
  aiChat_pickChannelTitle: 'Pilih kumpulan untuk siar',
  aiChat_matchingChannelTitle: 'Mencari kumpulan yang sesuai untuk anda',
  aiChat_matchingChannelHint: 'AI sedang mencari berdasarkan permintaan anda — biasanya beberapa saat hingga setengah minit',
  aiChat_matchUnavailableTitle: 'Cadangan tidak tersedia',
  aiChat_matchUnavailableHint: 'Cari kumpulan di bawah, atau tutup dan buka semula penerbitan',
  aiChat_waitSlowHint: 'Lebih lambat daripada biasanya, tetapi masih diproses — tunggu sebentar, atau cari kumpulan di bawah',
  aiChat_creatingSlowHint: 'Penciptaan kumpulan lebih lambat daripada biasanya, tetapi masih diproses — selepas ini terus siar',
  aiChat_pickChannelEmptyHint: 'Tiada kumpulan berkaitan ditemui. Cipta kumpulan baharu untuk menyiarkan mesej anda',
  aiChat_loadMore: 'Muat Lagi',
  sidebar_publish: 'Posting',
  chat_selectLocationOnMap: 'Sila pilih lokasi di peta',

  // App.vue new
  placeholder_email: 'Masukkan e-mel',
  placeholder_mobile: 'Masukkan nombor telefon',
  placeholder_password: 'Masukkan kata laluan',
  placeholder_name: 'Masukkan nama anda',
  random_nickname: 'Rawak',
  placeholder_verification_code: 'Masukkan kod pengesahan',
  sending: 'Menghantar...',
  registering: 'Mendaftar...',
  send_code: 'Hantar Kod',
  retry_in_seconds: 'Cuba lagi dalam {countdown}s',
  toast_enter_email: 'Masukkan e-mel',
  toast_enter_mobile: 'Masukkan nombor telefon',
  toast_invalid_email: 'Sila masukkan format e-mel yang sah',
  toast_invalid_mobile: 'Sila masukkan nombor telefon yang sah',
  toast_send_code_failed: 'Gagal menghantar kod pengesahan',
  toast_code_sent: 'Kod pengesahan dihantar ke e-mel',
  toast_code_sent_sms: 'Kod pengesahan dihantar ke telefon',
  toast_send_code_error: 'Gagal menghantar kod pengesahan, sila cuba lagi kemudian',
  toast_fill_all_fields: 'Sila isi semua medan',
  toast_login_failed: 'Log masuk gagal',
  toast_login_success: 'Berjaya log masuk',
  oauthOr: 'atau',
  toast_oauth_login_failed: 'Log masuk Google gagal',
  toast_oauth_login_error: 'Ralat log masuk Google, sila cuba lagi',
  toast_login_error: 'Log masuk gagal, sila cuba lagi kemudian',
  toast_register_failed: 'Pendaftaran gagal',
  toast_register_success: 'Berjaya mendaftar',
  toast_register_error: 'Pendaftaran gagal, sila cuba lagi kemudian',

  // AdBanner.vue
  ad: 'Iklan',

  // ContactAdGate.vue 联系前广告闸门
  contactAd_gateTitle: 'Sebelum berhubung',
  contactAd_gateSubtitle: 'Jeda singkat ini memastikan OctoSay kekal percuma — terima kasih atas sokongan anda!',
  contactAd_waitBtn: 'Sambung selepas {sec}s',
  contactAd_continueBtn: 'Teruskan ke sembang',

  // ChannelDetail.vue 私聊按钮
  session_privateChat: 'Sembang',

  // AiMatch.vue
  ai_welcome_msg: 'Hai, saya AI. Beritahu saya apa yang ada dalam fikiran anda — teman, pasangan, pertukaran kemahiran, atau APA SAJA.',
  default_username: 'Pengguna',

  // AvatarCropDialog.vue
  crop_hint: 'Cubit untuk zum, seret untuk melaraskan',
  toast_crop_failed: 'Gagal memotong imej',

  // ChatBox.vue
  loading_match_info: 'Memuatkan maklumat padanan...',
  view_match_details: 'Lihat butiran padanan',
  step_clarify_needs: 'Jelaskan',
  step_ai_matching: 'Siar ke Kumpulan',
  step_connect: 'Padanan AI',
  make_private: 'Jadikan Peribadi',
  setting: 'Menetapkan...',
  action_photo: 'Foto',
  action_file: 'Fail',
  action_video: 'Video',
  action_location: 'Lokasi',
  hint_get_app: 'Dapatkan aplikasi untuk kekal berhubung',
  match_finding_title: 'Padanan Anda',
  match_finding_subtitle: 'AI terus memadankan untuk anda',
  match_time_hint: 'Proses ini biasanya mengambil masa 1-2 minit',
  match_result_stats: 'Menemui {matched} padanan terbaik{interested}',
  match_tap_to_connect: 'Ketik untuk memulakan perbualan',
  match_channel_hint: 'Memadankan dalam hub <strong>#{channel}</strong>. Mengutamakan padanan dalam hub yang sama, tetapi mungkin termasuk hub lain apabila diperlukan.',
  label_perfect_match: 'Padanan Terbaik',
  label_worth_a_look: 'Berbaloi Dilihat',
  match_no_result_title: 'Masih mencari padanan untuk anda',
  match_no_result_desc: 'Kongsi lebih banyak butiran untuk membantu OctoSay mencari padanan yang tepat. Pasang aplikasi untuk menerima pemberitahuan apabila seseorang dipadankan dengan anda.',
  go_back: 'Kembali',
  no_public_requirements: 'Belum ada siaran awam',
  channelEmpty_title: 'Masih sunyi di sini',
  channelEmpty_subtitle: 'Jadilah yang pertama berkongsi idea',
  channelEmpty_hint: "Tulis idea anda dan AI akan membantu anda menjelaskan dan terus memadankan, supaya mesej anda tidak tenggelam",
  channelEmpty_action: 'Kongsi idea anda',
  stay_connected: 'Kekal Berhubung',
  download_app_desc: 'Dapatkan Aplikasi untuk berbual dan menerima pemberitahuan serta-merta apabila seseorang menghubungkan anda!',
  app_store: 'App Store',
  google_play: 'Google Play',
  direct_apk: 'APK Terus',
  match_history: 'Sejarah Padanan',
  no_match_history: 'Belum ada sejarah padanan',
  finding_matches: 'AI terus mencari padanan untuk anda - Selepas menyiarkan mesej ke hub',
  discover_connect_hint: 'Anda boleh berbual dengan mereka selepas dipadankan!',
  match_initializing: 'Memulakan...',
  placeholder_login_to_chat: 'log masuk untuk memberitahu apa yang ada dalam fikiran anda',
  toast_need_clear: 'Ide anda sudah jelas!',
  toast_ai_responding: 'AI sedang membalas, sila tunggu...',
  toast_uploading_image: 'Memuat naik imej, sila tunggu...',
  toast_uploading_file: 'Memuat naik fail, sila tunggu...',
  toast_max_photos: 'Maksimum {max} foto dibenarkan',
  toast_uploading: 'Memuat naik, sila tunggu...',
  toast_file_too_large: '{name} melebihi had 5MB',
  toast_video_too_large: '{name} melebihi had 20MB',
  toast_video_processing: 'Video sedang diproses, sila tunggu...',
  toast_upload_link_failed: 'Gagal mendapatkan pautan muat naik',
  analyzing_image: 'Menganalisis imej...',
  toast_location_confirmed: 'Lokasi disahkan',
  toast_location_selected: 'Lokasi dipilih',
  toast_enter_search: 'Sila masukkan kandungan carian',
  toast_search_failed: 'Carian gagal',
  toast_no_locations: 'Tiada lokasi ditemui',
  toast_search_error: 'Carian gagal, sila cuba lagi',
  toast_located_at: 'Ditemui di: {address}',
  toast_shared_finding: 'Dikongsi! Mencari padanan...',
  toast_update_failed: 'Kemas kini gagal',
  toast_set_private: 'Ditetapkan sebagai peribadi',
  toast_no_matches: 'Tiada padanan ditemui',
  toast_matches_found: 'Menemui {count} padanan terbaik',
  toast_start_conversation_first: 'Sila mulakan perbualan dahulu',
  toast_load_history_failed: 'Gagal memuatkan sejarah padanan',
  toast_ai_timeout: 'AI melampaui masa, sila cuba lagi',
  toast_message_blocked: 'Mesej disekat',
  network_disconnected: 'Rangkaian terputus',
  toast_publish_success: 'Disiarkan ke hub!',
  toast_publish_failed: 'Gagal menyiarkan ke hub',

  // ChatMsgList.vue
  collapse_thinking: 'tutup proses pemikiran',
  expand_thinking: 'buka proses pemikiran',
  thinking: 'sedang berfikir',
  select_date: 'Pilih Tarikh',
  selected_location: 'Lokasi Dipilih',
  msg_blocked: 'Disekat',
  retry: 'Cuba Lagi',
  msg_read: 'Dibaca',
  msg_sent: 'Dihantar',
  msg_unread: 'Belum dibaca',
  label_start_datetime: 'Tarikh & Masa Mula:',
  label_end_datetime: 'Tarikh & Masa Tamat:',
  toast_select_start_datetime: 'Sila pilih tarikh dan masa mula',
  toast_end_before_start: 'Tarikh-masa tamat tidak boleh lebih awal daripada tarikh-masa mula',
  report_message: 'Laporkan Mesej',
  block_user: 'Sekat Pengguna',
  msg_revoke: 'Tarik Balik',
  msg_quote: 'Petik',
  msg_revoked_self: 'Anda menarik balik mesej',
  msg_revoked_other: 'Pihak lain menarik balik mesej',
  // Neutral text inside quote block: the revoker is the sender of the quoted message, unrelated to current message direction
  msg_revoked_generic: 'Mesej ditarik balik',
  // Platform removal (content moderation manual review), distinct from self-revoke
  msg_revoked_platform: 'Mesej ini telah ditarik balik oleh platform kerana melanggar peraturan',
  msg_blocked_label: 'This message was blocked by the platform',
  toast_revoke_success: 'Mesej ditarik balik',
  toast_revoke_failed: 'Gagal menarik balik mesej',
  toast_load_data_failed: 'Gagal memuatkan data, sila muat semula.',
  toast_file_url_missing: 'URL fail tidak ditemui',
  toast_block_success: 'Pengguna berjaya disekat',
  toast_block_failed: 'Gagal menyekat pengguna',

  // ChatSession.vue
  no_more_records: 'tiada lagi rekod.',
  title_needs_clarified: 'Pemikiran Dijelaskan',
  title_clarifying: 'Menjelaskan Pemikiran Anda',
  title_public: 'Awam',
  title_private: 'Peribadi',
  badge_clarified: 'Dijelaskan',
  badge_clarifying: 'Sedang Dijelaskan',
  badge_only_me: 'Hanya Saya',
  badge_expired: 'Tamat tempoh',
  title_expired: 'Tamat tempoh',
  no_chat_history: 'Tiada sejarah sembang',

  // ContactMethods.vue
  block_status_banner: 'Anda telah menyekat pengguna ini',
  unblock_user: 'Nyahsekat',
  toast_block_missing_id: 'Tidak dapat menyekat: ID pengguna tiada',
  dialog_block_confirm: 'Adakah anda pasti mahu menyekat {name}? Anda tidak akan menerima sebarang mesej daripadanya.',
  toast_user_blocked: '{name} telah disekat',
  toast_unblock_missing_id: 'Tidak dapat menyahsekat: ID pengguna tiada',
  toast_user_unblocked: '{name} telah dinyahsekat',

  // BlockedUsers.vue
  blocked_users: 'Pengguna Disekat',
  blocked_users_empty: 'Tiada pengguna disekat',
  blocked_users_empty_hint: 'Pengguna yang disekat tidak dapat menghantar mesej kepada anda lagi',
  blocked_users_unblock: 'Nyahsekat',
  dialog_unblock_confirm: 'Selepas dinyahsekat, mereka dapat menghantar mesej kepada anda semula.',
  toast_unblock_success: 'Dinyahsekat',
  toast_unblock_failed: 'Gagal menyahsekat, sila cuba lagi',
  blocked_users_load_failed: 'Gagal memuatkan. Ketik untuk cuba lagi',
  blocked_users_blocked_at: 'Disekat {date}',
  blocked_users_unknown_user: 'Pengguna tidak dikenali',

  // Contacts.vue
  no_connections: 'Belum ada mesej',
  chat_with: 'Berbual dengan {name}',
  toast_load_contacts_failed: 'Gagal memuatkan kenalan: {msg}',
  toast_load_contacts_error: 'Gagal memuatkan kenalan. Sila muat semula dan cuba lagi.',
  time_just_now: 'Baru sahaja',
  time_minutes_ago: '{min}m lalu',
  time_hours_ago: '{hour}j lalu',
  time_days_ago: '{day}h lalu',

  // InteractionNotification.vue
  interaction_notification_title: 'Pemberitahuan',
  interaction_notification_subtitle: 'Ulasan & Suka',
  interaction_notification_empty: 'Belum ada pemberitahuan',
  interaction_notification_comment: 'mengulas: {content}',
  interaction_notification_like: 'menyukai siaran anda',
  interaction_notification_reply: 'membalas: {content}',
  interaction_notification_bookmark: 'menyimpan siaran anda',
  toast_load_notifications_failed: 'Gagal memuatkan pemberitahuan: {msg}',
  toast_load_notifications_error: 'Gagal memuatkan pemberitahuan. Sila muat semula dan cuba lagi.',
  mark_all_read: 'Tanda semua sebagai dibaca',
  toast_mark_all_read_failed: 'Gagal menanda semua dibaca, sila cuba lagi',
  contacts_dnd: 'Senyapkan Pemberitahuan',
  dnd_enabled: 'Pemberitahuan disenyapkan',
  dnd_disabled: 'Pemberitahuan dinyahsenyap',
  dnd_action_enable: 'Senyapkan Pemberitahuan',
  dnd_action_disable: 'Nyahsenyap Pemberitahuan',

  // Discover.vue
  toast_load_sessions_failed: 'Gagal memuatkan sesi: {msg}',
  toast_load_sessions_error: 'Gagal memuatkan sesi',
  discover_noMessages: 'Belum ada mesej',

  // EmojiInputArea.vue
  placeholder_default: 'Kongsi lebih banyak butiran dengan AI',
  userChat_typeMessage: 'Taip mesej...',
  select_emoji: 'Pilih Emoji',
  badge_new: 'baharu',
  channel_search_placeholder: 'Masukkan saluran',
  channel_picker_empty: 'Masukkan saluran',

  // FrontPage.vue
  tab_chat_with_ai: 'Biar OctoSay Memahami Anda',
  history_chats: 'Sejarah',
  tab_connections: 'Padanan',
  tab_conversations: 'Mesej',
  tab_profile: 'Profil',
  new_session: 'Baharu',
  history_tab_chats: 'Milik Saya',
  history_tab_matches: 'Padanan',
  channels_octosay: 'Kumpulan Octo',
  tab_matches: 'Padanan',
  tab_messages: 'Mesej',

  // Header.vue
  slogan: 'OctoSay - AI yang memahami anda dan memadankan anda dengan orang yang sesuai',
  app_name: 'OctoSay',
  slogan_short: 'AI yang memahami anda dan memadankan anda dengan orang yang sesuai',
  slogan_ai: 'AI yang memahami anda dan memadankan anda dengan orang yang sesuai',
  get_the_app: 'Dapatkan Aplikasi',
  desc_iphone_ipad: 'iPhone / iPad',
  desc_android: 'Android',
  search_in_app_stores: 'atau cari OctoSay di app store',

  // MapLocationPicker.vue
  placeholder_search_location: 'Cari lokasi...',
  coords_display: 'Bujur: {lng}, Lintang: {lat}',
  toast_no_geolocation: 'Pelayar anda tidak menyokong geolokasi',
  toast_location_permission_denied: 'Tidak dapat mendapatkan lokasi anda, sila semak kebenaran lokasi',
  loading_address: 'Memuatkan alamat...',

  // MatchedSession.vue
  created_at: 'Dicipta: {time}',
  ai_match_analysis: 'Analisis Padanan AI',
  error_missing_session_params: 'Parameter sesi yang diperlukan tidak lengkap',
  match_private_hint: 'Sesi ini peribadi. Kandungan tidak tersedia',

  // PersonalCenter.vue
  label_name: 'Nama:',
  placeholder_enter_name: 'Masukkan nama anda',
  label_bio: 'Bio:',
  placeholder_enter_bio: 'Tulis sesuatu tentang diri anda',
  placeholder_bio_empty: 'Katakan sesuatu tentang diri anda',
  bio: 'Bio',
  delete_account: 'Padam Akaun',
  delete_warning: 'Tindakan ini tidak boleh dibatalkan.',
  delete_data_intro: 'Data berikut akan dipadam secara kekal:',
  delete_item_profile: 'Maklumat profil anda',
  delete_item_chat: 'Sejarah dan sesi sembang',
  delete_item_contact: 'Maklumat kenalan',
  delete_item_all: 'Semua data berkaitan',
  final_confirmation: 'Pengesahan Akhir',
  delete_confirm_prompt: 'Taip "delete" untuk mengesahkan:',
  placeholder_type_delete: 'Taip delete',
  private_token: 'Token Peribadi',
  token_desc: 'Jana token untuk akses API',
  toast_not_logged_in: 'Pengguna belum log masuk',
  toast_name_required: 'Nama diperlukan',
  toast_save_success: 'Berjaya disimpan',
  toast_save_failed: 'Gagal menyimpan',
  toast_image_too_large: 'Imej melebihi had 5MB',
  toast_avatar_updated: 'Avatar dikemas kini',
  toast_avatar_failed: 'Gagal mengemas kini avatar',
  toast_upload_failed: 'Muat naik gagal',
  toast_token_generated: 'Token dijana',
  toast_token_failed: 'Gagal menjana token',
  toast_copied: 'Disalin ke papan keratan',
  toast_copy_failed: 'Gagal menyalin',
  toast_account_deleted: 'Akaun berjaya dipadam',
  toast_delete_account_failed: 'Gagal memadam akaun',
  toast_logout_success: 'Berjaya log keluar',
  toast_logout_failed: 'Gagal log keluar',
  profile_tab_messages: 'Mesej',
  profile_tab_comments: 'Ulasan',
  profile_tab_likes: 'Suka',
  profile_tab_bookmarks: 'Disimpan',
  profile_empty_messages: 'Belum ada mesej',
  profile_empty_comments: 'Belum ada ulasan',
  profile_empty_likes: 'Belum ada suka',
  profile_empty_bookmarks: 'Belum ada simpanan',
  profile_reply_to: 'Membalas {name}',
  profile_stats_posts: 'Mesej',
  profile_stats_comments: 'Ulasan',
  profile_stats_likes: 'Suka Diterima',
  profile_joined: 'Menyertai {date}',

  // ReportDialog.vue
  report_message_title: 'Laporkan Mesej',
  report_reason_prompt: 'Sila pilih sebab melaporkan mesej ini:',
  report_spam: 'Spam',
  report_harassment: 'Gangguan atau buli',
  report_inappropriate: 'Kandungan tidak sesuai',
  report_other: 'Lain-lain',
  placeholder_report_desc: 'Huraikan masalahnya (pilihan)',
  toast_select_reason: 'Sila pilih sebab',
  toast_report_success: 'Laporan berjaya dihantar',
  toast_report_failed: 'Gagal menghantar laporan',

  // common.js
  ellipsis: '..',

  // ChatBox.vue / ChatMsgList.vue message summary prefixes
  summary_image: '[Imej]',
  summary_images: '[Imej x{count}]',
  summary_file: '[Fail]',
  summary_files: '[Fail x{count}]',
  summary_video: '[Video]',
  summary_videos: '[Video x{count}]',
  summary_location: '[Lokasi]',
  summary_locations: '[Lokasi x{count}]',
  summary_emoji: '[Emoji]',
  summary_emojis: '[Emoji x{count}]',
  summary_voice: '[Suara]',
  summary_voices: '[Suara x{count}]',
  summary_mixed: '[Bercampur]',
  summary_other: '[Lain-lain]',

  // Voice messages
  voice: 'Suara',
  voice_recording: 'Merekod...',
  toast_voice_too_short: 'Rakaman terlalu pendek',
  toast_voice_failed: 'Gagal menghantar suara',
  toast_mic_permission_denied: 'Tidak dapat mengakses mikrofon. Sila aktifkan dalam tetapan pelayar',
  toast_recording_not_supported: 'Perakaman suara tidak disokong oleh pelayar ini',
  voice_load_failed: 'Gagal memuatkan mesej suara',

  // Expire At
  aiChat_expireLine: 'Sah sehingga {date}, beritahu AI pada bila-bila masa untuk mengemas kini',
  aiChat_expireExpired: 'Kandungan telah tamat tempoh dan tidak lagi dipaparkan kepada orang lain. Beritahu AI pada bila-bila masa untuk mengemas kini tempoh',

  // MatchedSession.vue
  detail: 'Butiran',

  // Match notification hints
  match_new_result_hint: 'Jika ada keputusan padanan baharu, anda akan diberitahu melalui e-mel. Untuk pengalaman lebih baik, pasang aplikasi untuk menerima pemberitahuan serta-merta.',

  // Match notification hints
  match_connection_notify_hint: 'Padanan dibuat dan diberitahu! Pergi ucapkan hai!',
  match_continuousMatching: 'AI terus memadankan untuk anda',
  match_continuousMatchingHint: 'Kami akan beritahu anda sebaik sahaja padanan baharu ditemui',
  match_continuousMatchingOthers: 'AI terus memadankan untuk mereka',
  match_continuousMatchingOthersHint: 'Padanan baharu akan muncul di sini apabila ditemui',
  match_noResultsTitleOthers: 'Masih mencari padanan untuk mereka',
  match_noResultsHintOthers: 'AI terus memadankan untuk mereka. Keputusan akan dipaparkan di sini sebaik sahaja ditemui.',
  match_newMatchFound: '{n} padanan baharu ditemui!',
  match_worth_exploring_hint: 'Anda tentukan sendiri sama ada mahu menghubungi.',

  // Matches filter tags
  filter_all: 'Semua',
  filter_best_connection: 'Padanan Terbaik',
  filter_worth_a_look: 'Berbaloi Dilihat',

  // LandingPage.vue (CN Portal)
  landing_brand_slogan: 'OctoSay - AI yang memahami anda dan memadankan anda dengan orang yang sesuai',
  landing_hero_title: 'Tulis dalam hub anda — AI jelaskan dahulu, kemudian anda siarkan dan dapat padanan.',
  landing_hero_subtitle: 'Taip mesej yang anda ingin kongsi dalam Kumpulan Octo. Sebelum ia disiarkan, AI akan berbual dengan anda untuk memastikan butirannya. Selepas anda mengesahkan, mesej dan ringkasan AI disiarkan bersama, dan AI mula memadankan.',
  landing_download_on: 'Muat turun di',
  landing_get_it_on: 'Dapatkan di',
  landing_direct_download: 'Muat Turun Terus',
  landing_how_title: 'Cara Ia Berfungsi',
  landing_step1_title: 'Tulis dalam Kumpulan',
  landing_step1_desc: 'Taip mesej yang anda ingin kongsi dalam hub. AI akan berbual dengan anda dahulu untuk menjelaskan butiran, supaya setiap siaran jelas, berguna dan sedia untuk dipadankan — tidak tenggelam dalam kebisingan.',
  landing_step2_title: 'Sahkan, Siar & Dapatkan Padanan',
  landing_step2_desc: 'Apabila anda mengesahkan, mesej asal dan ringkasan AI disiarkan bersama ke dalam hub. Kemudian AI terus mencari padanan terbaik anda, supaya mesej anda tidak tenggelam atau diabaikan.',
  landing_step3_title: 'Berhubung & Berbual',
  landing_step3_desc: 'Apabila padanan ditemui, kedua-dua pihak boleh melihat sejarah sembang masing-masing dengan AI dan ringkasan AI. Dengan konteks yang dikongsi, memecah air batu jadi mudah — hanya berbual secara semula jadi.',
  // Comparison Section
  landing_comparison_title: 'Kenapa OctoSay?',
  landing_comparison_subtitle: 'Sembang hub, tetapi AI menjelaskan butiran anda dan memadankan anda secara aktif.',
  landing_comparison_other: 'Discord',
  landing_comparison_octo: 'OctoSay',
  landing_cmp1_label: 'Kualiti Kandungan',
  landing_cmp1_other: 'Spam, iklan dan mesej luar topik membanjiri',
  landing_cmp1_octo: 'Hanya kad keperluan pilihan AI',
  landing_cmp2_label: 'Mencari Orang',
  landing_cmp2_other: 'Siar dan hanya tunggu balasan',
  landing_cmp2_octo: 'AI aktif memadankan anda',
  landing_cmp3_label: 'Tahap Kebisingan',
  landing_cmp3_other: 'Ratusan mesej untuk dilayari',
  landing_cmp3_octo: 'Sifar kebisingan, setiap siaran bermakna',
  landing_cmp4_label: 'Untuk Bermula',
  landing_cmp4_other: 'Cari pelayan, layari saluran, belajar sendiri',
  landing_cmp4_octo: 'Taip dalam hub; AI jelaskan dan padankan',
  landing_cmp_other_wechat: 'WeChat',
  landing_cmp_other_xhs: 'Xiaohongshu',
  landing_cmp_other_facebook: 'Facebook',
  landing_cmp_other_reddit: 'Reddit',
  landing_cmp1_wechat: 'Sembang kumpulan banjir iklan & spam',
  landing_cmp1_xhs: 'Siaran promosi di mana-mana, sukar dipercayai',
  landing_cmp1_facebook: 'Iklan dan umpan klik membanjiri suapan anda',
  landing_cmp1_reddit: 'Spam dan siaran luar topik di mana-mana',
  landing_cmp2_wechat: 'Hanya melalui kenalan dan jemputan kumpulan',
  landing_cmp2_xhs: 'Cari sendiri dan menggali siaran',
  landing_cmp2_facebook: 'Terhad kepada rakan & kumpulan sedia ada',
  landing_cmp2_reddit: 'Layari subreddit sendiri dan berharap ada balasan',
  landing_cmp3_wechat: 'Menyemak ratusan mesej kumpulan',
  landing_cmp3_xhs: 'Suapan penuh cadangan dan iklan',
  landing_cmp3_facebook: 'Siaran cadangan & iklan tanpa henti',
  landing_cmp3_reddit: 'Ratusan ulasan untuk dilayari',
  landing_cmp5_label: 'Siapa yang Mencari',
  landing_cmp5_wechat: 'Tanya satu persatu, berharap nasib baik',
  landing_cmp5_xhs: 'Siar, tunggu ulasan, tapis sendiri',
  landing_cmp5_facebook: 'Anda terpaksa bertanya ke sana ke mari dalam kumpulan',
  landing_cmp5_reddit: 'Siar, tunggu balasan, kemudian tapis',
  landing_cmp5_octo: 'AI terus mencari orang untuk anda, secara automatik',

  landing_features_title: 'Ciri Utama',
  landing_feature1_title: 'Jelaskan Sebelum Menyiarkan',
  landing_feature1_desc: 'Tiada borang perlu diisi. Taip mesej anda dalam hub dan AI akan berbual dengan anda dahulu untuk bertanya soalan yang betul dan benar-benar memahami keperluan anda.',
  landing_feature2_title: 'Bersih, Bukan Bercelaru',
  landing_feature2_desc: 'Mesej dan ringkasan AI anda disiarkan bersama — OctoSay mengkurasi setiap siaran, jadi tiada spam, tiada kebanjiran luar topik, tiada kebisingan untuk dilayari.',
  landing_feature3_title: 'Pemadanan Proaktif',
  landing_feature3_desc: 'Selepas anda mengesahkan dan mesej + ringkasan AI anda disiarkan, AI terus mengimbas hub untuk mencari orang yang sesuai dengan apa yang anda cari — dan menerangkan sebabnya.',
  landing_feature4_title: 'Komuniti Topik, Sifar Kebisingan',
  landing_feature4_desc: 'Sertai hub topik — sukan, permainan, pertukaran bahasa, rakan sebilik — AI menjelaskan mesej anda sebelum menyiarkan, jadi setiap hub kekal bersih dan berguna.',
  landing_feature5_title: 'Privasi Terlindung',
  landing_feature5_desc: 'Anda boleh menjadikan mesej peribadi selepas menghantar, dipaparkan hanya kepada anda. Kawalan penuh.',
  landing_feature6_title: 'Perbualan Bermakna',
  landing_feature6_desc: 'Tiada kebisingan, tiada gangguan—setiap mesej bermakna.',
  landing_usecases_title: 'Berfungsi untuk Sebarang Senario',
  landing_usecases_subtitle: 'Apa pun yang ada dalam fikiran anda, sertai hub topik — AI mengurus pemadanan supaya anda tidak perlu melayari dan mencari',
  landing_usecase_game: 'Rakan Bermain',
  landing_usecase_language: 'Pertukaran Bahasa',
  landing_usecase_skill: 'Pertukaran Kemahiran',
  landing_usecase_roommate: 'Cari Rakan Sebilik',
  landing_usecase_travel: 'Rakan Kembara',
  landing_usecase_sports: 'Partner Sukan',
  landing_usecase_study: 'Partner Belajar',
  landing_usecase_anything: '...atau kongsi apa sahaja',
  landing_cta_title: 'Sedia untuk Bermula?',
  landing_cta_desc: 'Sertai hub topik, tulis apa yang anda ingin kongsi, biarkan AI menjelaskan butirannya, kemudian siarkan dan dapatkan padanan dengan orang yang sesuai.',
  landing_use_now: 'Guna Sekarang',
  landing_groups: 'Kumpulan',

  // OnboardingPage.vue
  onboarding_skip: 'Langkau',
  onboarding_next: 'Seterusnya',
  onboarding_getStarted: 'Mula',
  onboarding_step1Title: "Katakan apa yang anda mahu di hub",
  onboarding_step1Desc: "Apa sahaja yang anda cari atau mahu lakukan, katakan sahaja. AI akan berbual dengan anda untuk menjelaskan butiran dan menukarnya kepada keperluan yang jelas.",
  onboarding_step2Title: 'Sahkan, Siar & Dapatkan Padanan',
  onboarding_step2Desc: "Apabila mesej anda disiarkan ke dalam hub, AI akan terus mencari padanan terbaik anda, supaya mesej anda tidak tenggelam atau diabaikan.",
  onboarding_step3Title: 'Berhubung & Berbual',
  onboarding_step3Desc: "Kedua-dua pihak boleh melihat perbualan masing-masing dengan AI dan mengetahui apa yang dicari. Dengan konteks yang dikongsi, memecah air batu jadi mudah — hanya berbual secara semula jadi.",

  // ChannelDetail.vue
  channel_image_limit: 'Maksimum 1 imej',

  // ChannelMembers.vue
  channel_members_empty: 'Belum ada ahli',
  channel_members_title: 'Ahli',
  channel_role_owner: 'Pemilik',
  channel_role_admin: 'Admin',
  channel_role_member: 'Ahli',

  // Settings.vue
  settings_language: 'Bahasa',
  settings_language_followSystem: 'Ikut Sistem',

  // ChatBox.vue
  match_interested_suffix: ', {count} berbaloi dilihat',

  // ChatBox.vue - Peringkat kemajuan padanan AI
  match_stage_fetch_chat: 'Mengambil perbualan',
  match_stage_query_expansion: 'Mengembangkan pertanyaan',
  match_stage_semantic_search: 'Carian semantik',
  match_stage_deep_search: 'Analisis mendalam',
  match_stage_rerank: 'Penyesuaian pintar',
  match_stage_refining: 'Mengoptimumkan hasil',
  match_stage_fetch_details: 'Mengambil butiran',

  // ChannelDetail.vue - Muat naik imej
  channel_select_image: 'Sila pilih fail imej',
  channel_image_upload_failed: 'Muat naik imej gagal, sila cuba lagi',
  chatInput_channelSearchHint: "Cari kumpulan",
}



// WEBPACK FOOTER //
// ./src/i18n/ms.js